import * as types from "../../../services/types/location-type";

const initialState = {
    countries: [],
    gettingCities: false,
    cities: [],
};

const LocationReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case types.GET_COUNTRIES:
            return {
                ...state,
                countries: payload,
            };
        case types.GET_CITIES:
            return {
                ...state,
                cities: payload,
                gettingCities: false,
            };
        case types.GETTING_CITIES:
            return {
                ...state,
                gettingCities: payload,
            };
        default:
            return state;
    }
};

export default LocationReducer;
